<template>
    <div>
        <h2 class="subtitle">Site</h2>
        <div class="field">
            <label class="label">Description<br><span class="is-hint-text">(displayed under the page title in Google search, the value given here will be used as the default for individual projects too)</span></label>
            <div class="control">
                <textarea class="textarea" placeholder="Description" rows="3" v-model="description"></textarea>
            </div>
        </div>
        <div class="field">
            <label class="label">Keywords<br><span class="is-hint-text">(used for all pages, individual projects' keywords will be merged with these, press enter to add a new keyword)</span></label>
            <div class="control">
                <b-taginput placeholder="Keywords" v-model="keywords" />
            </div>
        </div>
        <hr>
        <h2 class="subtitle">Homepage</h2>
        <div class="field">
            <label class="label">Title<br><span class="is-hint-text">(each word will use alternating brightnesses)</span></label>
            <div class="control">
                <input class="input" type="text" placeholder="Title" v-model="title">
            </div>
        </div>
        <div class="field">
            <label class="label">Subtitle</label>
            <div class="control">
                <input class="input" type="text" placeholder="Subtitle" v-model="subtitle">
            </div>
        </div>
        <div class="field">
            <label class="label">Email</label>
            <div class="control">
                <input class="input" type="text" placeholder="Email" v-model="email">
            </div>
        </div>
        <div class="field">
            <label class="label">Instagram<br><span class="is-hint-text">(give full URL)</span></label>
            <div class="control">
                <input class="input" type="text" placeholder="Instagram" v-model="instagram">
            </div>
        </div>
        <!--<div class="field">
            <label class="label">Facebook<br><span class="is-hint-text">(give full URL)</span></label>
            <div class="control">
                <input class="input" type="text" placeholder="Facebook" v-model="facebook">
            </div>
        </div>
        <div class="field">
            <label class="label">Twitter<br><span class="is-hint-text">(give full URL)</span></label>
            <div class="control">
                <input class="input" type="text" placeholder="Twitter" v-model="twitter">
            </div>
        </div>
        <div class="field">
            <label class="label">Homepage Copyright<br><span class="is-hint-text">(<b>[copy]</b> will be replaced with the copyright symbol and <b>[year]</b> will be replaced with the current year)</span></label>
            <div class="control">
                <input class="input" type="text" placeholder="Homepage Copyright" v-model="homepageCopyright">
            </div>
        </div>-->
        <div class="field">
            <label class="label">View Button Text</label>
            <div class="control">
                <input class="input" type="text" placeholder="View Button Text (Homepage)" v-model="homepageViewText">
            </div>
        </div>
        <hr>
        <h2 class="subtitle">About</h2>
        <div class="field">
            <label class="label">About</label>
            <div class="control">
                <textarea class="textarea" placeholder="About" rows="15" v-model="aboutText"></textarea>
            </div>
        </div>
        <div class="field">
            <div class="label">Affiliate Images</div>
            <div class="control">
                <ul class="image-list">
                    <draggable v-model="images" :options="{handle: '.handle'}" @start="drag=true" @end="drag=false">
                        <li v-for="image of images" :key="image['.key']" class="box level is-mobile">
                            <div class="level-item handle">
                                <font-awesome-icon icon="bars" />
                            </div>
                            <article class="level-item media">
                                <figure class="media-left">
                                    <div @click="openImageModal(image)" class="image box is-ar-3by2"
                                         :style="{backgroundImage: image.imageUrl ? `url('${contentUrlPrefix + image.imageUrl}')` : 'none'}">
                                        <div v-if="!image.imageUrl" class="has-centered-content">
                                            <font-awesome-icon icon="hand-pointer" />
                                        </div>
                                    </div>
                                </figure>
                                <div class="media-content">
                                    <input class="input" type="text" placeholder="URL" v-model="image.url">
                                </div>
                                <div class="media-right">
                                    <button class="delete" @click="removeImage(image['.key'])"></button>
                                </div>
                            </article>
                        </li>
                    </draggable>
                </ul>
                <button class="button" @click="addImage" :style="{marginTop: `${images.length > 0 ? 1 : 0}rem`}">Add Image</button>
            </div>
        </div>
        <div class="field">
            <label class="label">About Copyright<br><span class="is-hint-text">(<b>[copy]</b> will be replaced with the copyright symbol and <b>[year]</b> will be replaced with the current year)</span></label>
            <div class="control">
                <input class="input" type="text" placeholder="About Copyright" v-model="aboutCopyright">
            </div>
        </div>
        <hr>
        <h2 class="subtitle">Projects Archive</h2>
        <div class="field">
            <label class="label">View Button Text</label>
            <div class="control">
                <input class="input" type="text" placeholder="View Button Text (Projects Archive)" v-model="projectsArchiveViewText">
            </div>
        </div>
        <hr>
        <h2 class="subtitle">Gallery</h2>
        <div class="field">
            <label class="label">Gallery Image Copyright<br><span class="is-hint-text">(<b>[copy]</b> will be replaced with the copyright symbol and <b>[year]</b> will be replaced with the current year)</span></label>
            <div class="control">
                <input class="input" type="text" placeholder="Gallery Image Copyright" v-model="galleryImageCopyright">
            </div>
        </div>
        <hr>
        <div class="field is-grouped">
            <div class="control">
                <button class="button is-primary" @click="save">Save</button>
            </div>
        </div>
        <transition name="modal">
            <image-modal v-show="imageModalShown"
                         v-model="imageModalUrl"
                         @close="imageModalShown = false"
                         @select="selectImage"/>
        </transition>
    </div>
</template>

<script>
import Draggable from 'vuedraggable';
import ImageModal from '../components/ImageModal';
import {PUSH_MESSAGE} from "../store";
import {mapState} from 'vuex';
import {generateKey} from "../utils";
import {contentUrlPrefix, triggerSiteBuild} from "../firebase";

export default {
    name: "meta-edit",
    data() {
        return {
            contentUrlPrefix,
            title: '',
            subtitle: '',
            description: '',
            keywords: [],
            aboutText: '',
            homepageCopyright: '',
            aboutCopyright: '',
            galleryImageCopyright: '',
            imageModalShown: false,
            imageModalUrl: '',
            imageModalKey: '',
            homepageViewText: '',
            projectsArchiveViewText: '',
            images: [],
            email: '',
            instagram: '',
            facebook: '',
            twitter: '',
        }
    },
    computed: {
        ...mapState(['meta'])
    },
    watch: {
        meta: {
            handler(meta) {
                if (meta) {
                    this.title = meta.title || '';
                    this.subtitle = meta.subtitle || '';
                    this.description = meta.description || '';
                    this.keywords = meta.keywords || [];
                    this.aboutText = meta.aboutText || '';

                    this.homepageCopyright = meta.homepageCopyright || '';
                    this.aboutCopyright = meta.aboutCopyright || '';
                    this.galleryImageCopyright = meta.galleryImageCopyright || '';

                    this.homepageViewText = meta.homepageViewText || '';
                    this.projectsArchiveViewText = meta.projectsArchiveViewText || '';

                    this.images = [];
                    for (let key of Object.keys(meta.aboutImages)) {
                        let image = meta.aboutImages[key];
                        this.images.push({
                            '.key': key,
                            url: image.url || '',
                            imageUrl: image.imageUrl || ''
                        });
                    }

                    this.email = meta.email || '';

                    this.instagram = meta.instagram || '';
                    this.facebook = meta.facebook || '';
                    this.twitter = meta.twitter || '';
                }
            },
            immediate: true
        }
    },
    methods: {
        addImage() {
            this.images.push({
                '.key': generateKey(),
                imageUrl: '',
                url: ''
            });
        },
        openImageModal(image) {
            this.imageModalUrl = image.imageUrl;
            this.imageModalKey = image['.key'];
            this.imageModalShown = true;
        },
        selectImage() {
            let image = this.images.find(image => image['.key'] === this.imageModalKey);
            image.imageUrl = this.imageModalUrl;
        },
        removeImage(key) {
            this.images = this.images.filter(image => image['.key'] !== key);
        },
        save() {
            this.$store.$firebaseRefs.meta
                .set({
                    title: this.title,
                    subtitle: this.subtitle,
                    description: this.description,
                    keywords: this.keywords,
                    aboutText: this.aboutText,
                    // aboutBottomImageUrl: this.aboutBottomImageUrl,
                    homepageCopyright: this.homepageCopyright,
                    aboutCopyright: this.aboutCopyright,
                    galleryImageCopyright: this.galleryImageCopyright,
                    homepageViewText: this.homepageViewText,
                    projectsArchiveViewText: this.projectsArchiveViewText,
                    email: this.email,
                    instagram: this.instagram,
                    facebook: this.facebook,
                    twitter: this.twitter
                });

            const imagesRef = this.$store.$firebaseRefs.meta
                .child("aboutImages");
            for (let image of this.images) {
                imagesRef.push({
                    url: image.url,
                    imageUrl: image.imageUrl
                });
            }

            triggerSiteBuild("Updated Meta");
            // noinspection JSIgnoredPromiseFromCall
            this.$store.dispatch(PUSH_MESSAGE, {
                title: "Success",
                message: "Meta saved! It may take up to 5 minutes for changes to be visible.",
                type: "success"
            });

            this.$router.push("/");
        }
    },
    components: {
        ImageModal,
        Draggable
    }
}
</script>

<style lang="scss">
    @import "~bulma/sass/utilities/initial-variables.sass";

    //noinspection CssOptimizeSimilarProperties
    .about-image {
        width: 180px;
        height: 120px;

        background-position: center;
        background-size: cover;
        background-color: $grey-light;
        box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);

        border-radius: 6px;

        cursor: pointer;

        div {
            width: 100%;
            height: 100%;

            svg {
                color: white;
            }
        }
    }
</style>